<template>
	<div class="omapi-no-connection">
		<div class="omapi-no-connection-title">
			<slot name="title">Your site is not connected to OptinMonster!</slot>
		</div>
		<div class="omapi-no-connection-subtitle">
			<slot name="subtitle">Connect your site now to start making campaigns live on your website.</slot>
		</div>
		<div v-if="hasFeatures" class="omapi-no-connection-features">
			<slot name="features"></slot>
		</div>
		<core-create-connect />
	</div>
</template>

<script>
export default {
	computed: {
		hasFeatures() {
			return !!this.$slots.features;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables';
.omapi-no-connection {
	text-align: center;

	&-title {
		font-size: 16px;
		line-height: 140%;
		font-weight: $font_bold;
	}
	&-subtitle,
	&-buttons {
		font-size: 13px;
		line-height: 150%;
		color: $font_setting-color;
		margin: 5px 0 15px;
		.omapi-button.omapi-button__medium {
			margin: 0 10px 10px;
			font-size: 14px;
		}
	}

	.omapi-no-connection-buttons {
		display: flex;
		justify-content: center;
		align-items: center;

		.omapi-button {
			margin-bottom: 0;
			padding: 10px;

			&:last-child {
				padding: 11px 10px;
			}
		}
	}
}
</style>
